/* eslint-disable consistent-return */
export const setInStorage = (key, value) => {
  try {
    sessionStorage.setItem(key, value);
  } catch (error) {
    return '';
  }
};

export const getFromStorage = key => {
  try {
    return sessionStorage.getItem(key);
  } catch {
    return '';
  }
};
